/* eslint-disable max-len */
import { randomBoolean } from '@/utils/generators'

const columns = [{
    headerName: 'Identification',
    children: [{
        headerName: 'Id',
        headerTooltip: '<h3>Validator:</h3><small><pre>unique = true</pre></small>',
        type: 'number',
        required: false,
        field: 'id',
    }, {
        headerName: 'Name',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>firmName</pre></small><br><h3>Validator:</h3><small><pre>required = true</pre></small>",
        type: 'string',
        required: true,
        editable: false,
        field: 'name',
    }, {
        headerName: 'Qef Id',
        headerTooltip: '<h3>Validator:</h3><small><pre>unique = true</pre></small>',
        type: 'number',
        required: false,
        field: 'qefId',
    }, {
        headerName: 'Preqin Id',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>firmId</pre></small><br><h3>Validator:</h3><small><pre>unique = true</pre></small>",
        type: 'decimal',
        required: false,
        field: 'preqinId',
    }],
}, {
    headerName: 'General information',
    children: [{
        headerName: 'Hq City',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>city</pre></small>",
        type: 'string',
        required: false,
        field: 'hqCity',
    }, {
        headerName: 'Link Arx',
        headerTooltip: null,
        type: 'bool',
        required: false,
        field: 'linkArx',
    }, {
        headerName: 'Website',
        headerTooltip: '<h3>Transform:</h3><small><pre>extractDomain</pre></small>',
        type: 'string',
        required: false,
        field: 'website',
    }, {
        headerName: 'Year Est',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'yearEst',
    }, {
        headerName: 'Num Funds',
        headerTooltip: '<h3>Calculated (if empty):</h3><small><pre>COUNT(funds) || undefined</pre></small><br><h3>Validator:</h3><small><pre>maxValue = 1000</pre></small><br><h3>Validator:</h3><small><pre>minValue = 0</pre></small>',
        type: 'number',
        required: false,
        field: 'numFunds',
    }, {
        headerName: 'Hq Address',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>address</pre></small>",
        type: 'string',
        required: false,
        field: 'hqAddress',
    }, {
        headerName: 'Hq Country',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>country</pre></small><br><h3>Dictionary:</h3><small><pre>COUNTRIES</pre></small>",
        type: 'flag',
        required: false,
        field: 'hqCountry',
        selectGroup: 'COUNTRIES',
        multiple: true,
        filterParams: {
            values: ['n/a', 'Chad', 'Cuba', 'Fiji', 'Guam', 'Iran', 'Iraq', 'Mali', 'Niue', 'Oman', 'Peru', 'Togo', 'Aruba', 'Benin', 'Chile', 'China', 'Congo', 'Egypt', 'Gabon', 'Ghana', 'Haiti', 'India', 'Italy', 'Japan', 'Kenya', 'Libya', 'Macao', 'Malta', 'Nauru', 'Nepal', 'Niger', 'Palau', 'Qatar', 'Samoa', 'Spain', 'Sudan', 'Syria', 'Tonga', 'Yemen', 'Angola', 'Belize', 'Bhutan', 'Brazil', 'Canada', 'Cyprus', 'France', 'Gambia', 'Greece', 'Guinea', 'Guyana', 'Israel', 'Jersey', 'Jordan', 'Kuwait', 'Latvia', 'Malawi', 'Mexico', 'Monaco', 'Norway', 'Panama', 'Poland', 'Russia', 'Rwanda', 'Serbia', 'Sweden', 'Taiwan', 'Turkey', 'Tuvalu', 'Uganda', 'Zambia', 'Albania', 'Algeria', 'Andorra', 'Armenia', 'Austria', 'Bahamas', 'Bahrain', 'Belarus', 'Belgium', 'Bermuda', 'Bolivia', 'Burundi', 'Comoros', 'Croatia', 'Denmark', 'Ecuador', 'Eritrea', 'Estonia', 'Finland', 'Georgia', 'Germany', 'Grenada', 'Hungary', 'Iceland', 'Ireland', 'Jamaica', 'Lebanon', 'Lesotho', 'Liberia', 'Mayotte', 'Moldova', 'Morocco', 'Myanmar', 'Namibia', 'Nigeria', 'Reunion', 'Romania', 'Senegal', 'Somalia', 'Tokelau', 'Tunisia', 'Ukraine', 'Uruguay', 'Vanuatu', 'Vietnam', 'Anguilla', 'Barbados', 'Botswana', 'Bulgaria', 'Cambodia', 'Cameroon', 'Colombia', 'Djibouti', 'Dominica', 'Ethiopia', 'Guernsey', 'Honduras', 'Kiribati', 'Malaysia', 'Maldives', 'Mongolia', 'Pakistan', 'Paraguay', 'Portugal', 'Slovakia', 'Slovenia', 'Suriname', 'Tanzania', 'Thailand', 'Zimbabwe', 'Argentina', 'Australia', 'Gibraltar', 'Greenland', 'Guatemala', 'Hong Kong', 'Indonesia', 'Lithuania', 'Macedonia', 'Mauritius', 'Nicaragua', 'Palestine', 'Singapore', 'Sri Lanka', 'Swaziland', 'Venezuela', 'Antarctica', 'Azerbaijan', 'Bangladesh', 'Cabo Verde', 'Costa Rica', 'Guadeloupe', 'Kazakhstan', 'Kyrgyzstan', 'Luxembourg', 'Madagascar', 'Martinique', 'Mauritania', 'Montenegro', 'Montserrat', 'Mozambique', 'San Marino', 'Seychelles', 'Tajikistan', 'Uzbekistan', 'Afghanistan', 'El Salvador', 'Isle of Man', 'Netherlands', 'New Zealand', 'North Korea', 'Philippines', 'Puerto Rico', 'Saint Lucia', 'South Korea', 'South Sudan', 'Switzerland', 'Timor-Leste', 'Burkina Faso', 'Cook Islands', 'Saint Helena', 'Saudi Arabia', 'Sierra Leone', 'South Africa', 'Turkmenistan', 'Bouvet Island', 'Faroe Islands', 'French Guiana', 'Guinea-Bissau', 'Liechtenstein', 'New Caledonia', 'United States', 'American Samoa', 'Cayman Islands', 'Czech Republic', "Côte D'Ivoire", 'Norfolk Island', 'United Kingdom', 'Western Sahara', 'Solomon Islands', 'Christmas Island', 'Marshall Islands', 'Papua New Guinea', 'Pitcairn Islands', 'Brunei Darussalam', 'Equatorial Guinea', 'US Virgin Islands', 'Wallis and Futuna', 'Dominican Republic', 'Antigua and Barbuda', 'Trinidad and Tobago', 'Netherlands Antilles', 'United Arab Emirates', 'Saint Kitts and Nevis', 'Sao Tome and Principe', 'Bosnia and Herzegovina', 'British Virgin Islands', 'Central African Republic', 'Northern Mariana Islands', 'Turks and Caicos Islands', 'Saint Pierre and Miquelon', 'Federated States of Micronesia', "Lao People's Democratic Republic", 'Saint Vincent and the Grenadines', 'Heard Island and McDonald Islands', 'Congo, The Democratic Republic of the'],
        },
    }, {
        headerName: 'Hq Region A',
        headerTooltip: '<h3>Dictionary:</h3><small><pre>REGIONS_A</pre></small><br><h3>Calculated (if empty):</h3><small><pre>hqCountry</pre></small><br><h3>Style:</h3><small><pre>redIfUnknown</pre></small>',
        type: 'select',
        required: false,
        field: 'hqRegionA',
        selectGroup: 'REGIONS_A',
        multiple: true,
        filterParams: {
            values: ['DACH', 'Italy', 'Africa', 'Europe', 'France', 'Global', 'Nordic', 'Benelux', 'Americas', 'Arab States', 'Latin America', 'North America', 'Asia & Pacific', 'Rest of Europe', 'United Kingdom', 'Frontier/Emerging Markets'],
        },
    }, {
        headerName: 'Hq Region B',
        headerTooltip: '<h3>Dictionary:</h3><small><pre>REGIONS_B</pre></small><br><h3>Calculated (if empty):</h3><small><pre>hqRegionA</pre></small><br><h3>Style:</h3><small><pre>redIfUnknown</pre></small>',
        type: 'select',
        required: false,
        field: 'hqRegionB',
        selectGroup: 'REGIONS_B',
        multiple: true,
        filterParams: {
            values: ['Africa', 'Europe', 'Global', 'Arab States', 'Latin America', 'North America', 'Asia & Pacific', 'Frontier/Emerging Markets'],
        },
    }, {
        headerName: 'Hq Zipcode',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>zipCode</pre></small>",
        type: 'string',
        required: false,
        field: 'hqZipcode',
    }, {
        headerName: 'Link Preqin',
        headerTooltip: null,
        type: 'string',
        required: false,
        field: 'linkPreqin',
    }, {
        headerName: 'Description',
        headerTooltip: null,
        type: 'string',
        required: false,
        field: 'description',
    }, {
        headerName: 'Contact Email',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>email</pre></small>",
        type: 'email',
        required: false,
        field: 'contactEmail',
    }, {
        headerName: 'Main Currency',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>firmsMainCurrency</pre></small><br><h3>Dictionary:</h3><small><pre>CURRENCIES</pre></small>",
        type: 'select',
        required: false,
        field: 'mainCurrency',
        selectGroup: 'CURRENCIES',
        multiple: true,
        filterParams: {
            values: ['DM', 'AED', 'AUD', 'BRL', 'CAD', 'CHF', 'CLP', 'COP', 'DKK', 'EEK', 'EUR', 'GBP', 'HRK', 'HUF', 'ILS', 'ISK', 'JPY', 'KRW', 'MXN', 'NOK', 'NZD', 'PEN', 'PLN', 'RMB', 'RUB', 'SEK', 'SGD', 'TTD', 'TZS', 'USD', 'ZAR'],
        },
    }, {
        headerName: 'Fund Currencies',
        headerTooltip: "<h3>Dictionary:</h3><small><pre>CURRENCIES</pre></small><br><h3>Calculated (if empty):</h3><small><pre>UNIQUE(funds, 'fundCurrency')</pre></small>",
        type: 'select',
        required: false,
        field: 'fundCurrencies',
        selectGroup: 'CURRENCIES',
        multiple: true,
        filterParams: {
            values: ['DM', 'AED', 'AUD', 'BRL', 'CAD', 'CHF', 'CLP', 'COP', 'DKK', 'EEK', 'EUR', 'GBP', 'HRK', 'HUF', 'ILS', 'ISK', 'JPY', 'KRW', 'MXN', 'NOK', 'NZD', 'PEN', 'PLN', 'RMB', 'RUB', 'SEK', 'SGD', 'TTD', 'TZS', 'USD', 'ZAR'],
        },
    }, {
        headerName: 'Contact Telephone',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>tel</pre></small>",
        type: 'string',
        required: false,
        field: 'contactTelephone',
    }],
}, {
    headerName: 'Team',
    children: [{
        headerName: 'Admteam',
        headerTooltip: '<h3>Calculated (if empty):</h3><small><pre>admteamSenior + admteamOther</pre></small><br><h3>Style:</h3><small><pre>colorEmployeesNum</pre></small>',
        type: 'number',
        required: false,
        field: 'admteam',
    }, {
        headerName: 'Invteam',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>investmentTeamStaff</pre></small><br><h3>Calculated (if empty):</h3><small><pre>invteamPartner + invteamSenior + invteamJunior</pre></small><br><h3>Style:</h3><small><pre>colorEmployeesNum</pre></small>",
        type: 'number',
        required: false,
        field: 'invteam',
    }, {
        headerName: 'Opsteam',
        headerTooltip: '<h3>Calculated (if empty):</h3><small><pre>opsteamPartner + opsteamSenior + opsteamOther</pre></small><br><h3>Style:</h3><small><pre>colorEmployeesNum</pre></small>',
        type: 'number',
        required: false,
        field: 'opsteam',
    }, {
        headerName: 'Staff Total',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>totalStaff</pre></small><br><h3>Calculated (if empty):</h3><small><pre>invteam + opsteam + admteam</pre></small><br><h3>Style:</h3><small><pre>colorEmployeesNum</pre></small>",
        type: 'number',
        required: false,
        field: 'staffTotal',
    }, {
        headerName: 'Team Quality',
        headerTooltip: null,
        type: 'select',
        required: false,
        field: 'teamQuality',
        selectGroup: 'teamQuality',
        multiple: true,
        filterParams: {
            values: [],
        },
    }, {
        headerName: 'Admteam Other',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'admteamOther',
    }, {
        headerName: 'Opsteam Other',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'opsteamOther',
    }, {
        headerName: 'Admteam Senior',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'admteamSenior',
    }, {
        headerName: 'Invteam Junior',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'invteamJunior',
    }, {
        headerName: 'Invteam Senior',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'invteamSenior',
    }, {
        headerName: 'Opsteam Senior',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'opsteamSenior',
    }, {
        headerName: 'Invteam Partner',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'invteamPartner',
    }, {
        headerName: 'Opsteam Partner',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'opsteamPartner',
    }],
}, {
    headerName: 'GP strategy',
    children: [{
        headerName: 'Qef Region',
        headerTooltip: '<h3>Calculated (if empty):</h3><small><pre>getCoreCountries(coreCountries)</pre></small>',
        type: 'select',
        required: false,
        field: 'qefRegion',
        selectGroup: 'qefRegion',
        multiple: true,
        filterParams: {
            values: [],
        },
    }, {
        headerName: 'Company Size',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>peCompanySize</pre></small><br><h3>Dictionary:</h3><small><pre>COMPANIES</pre></small>",
        type: 'select',
        required: false,
        field: 'companySize',
        selectGroup: 'COMPANIES',
        multiple: true,
        filterParams: {
            values: ['n/a', 'Large', 'Small', 'Mid-Market'],
        },
    }, {
        headerName: 'Inv Position',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>peGpPositionInInvestment</pre></small>",
        type: 'select',
        required: false,
        field: 'invPosition',
        selectGroup: 'invPosition',
        multiple: true,
        filterParams: {
            values: ['Co-Lead', 'Lead', 'Co-investing', 'Sole Investor'],
        },
    }, {
        headerName: 'Core Industry',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>getCoreIndustries(peIndustries)</pre></small><br><h3>Calculated (if empty):</h3><small><pre>const industries = MEAN_LIST(funds, 'coreIndustry', 0.3);\nreturn getCoreIndustries(industries);\n</pre></small>",
        type: 'select',
        required: false,
        field: 'coreIndustry',
        selectGroup: 'coreIndustry',
        multiple: true,
        filterParams: {
            values: ['25', '45', '1010', '1510', '2010', '2020', '2030', '2510', '2520', '2530', '2550', '3020', '3510', '3520', '4020', '4030', '4510', '4520', '4530', '5010', '5020', '5510', '6010', 'Generalist (without focus)', 'Multi-sector (few key sectors)'],
        },
    }, {
        headerName: 'Main Strategy',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>peMainFirmStrategy</pre></small><br><h3>Dictionary:</h3><small><pre>GP_FIRM_STRATEGIES</pre></small><br><h3>Calculated (if empty):</h3><small><pre>MEAN(funds, 'allStrategies', 0.7)</pre></small>",
        type: 'select',
        required: false,
        field: 'mainStrategy',
        selectGroup: 'GP_FIRM_STRATEGIES',
        multiple: true,
        filterParams: {
            values: ['Buyout', 'Growth', 'Hybrid', 'Balanced', 'Turnaround', 'Real Assets', 'Co-investment', 'Direct Secondaries', 'Mezzanime/Debt/Loans', 'Venture / Late Stage'],
        },
    }, {
        headerName: 'Shareholding',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>peShareHolding</pre></small><br><h3>Dictionary:</h3><small><pre>SHAREHOLDING</pre></small>",
        type: 'select',
        required: false,
        field: 'shareholding',
        selectGroup: 'SHAREHOLDING',
        multiple: true,
        filterParams: {
            values: ['Minority', 'Controlling', 'No Preference', 'Prefer Minority', 'Prefer Controlling'],
        },
    }, {
        headerName: 'All Industries',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>getAllIndustries(peIndustries)</pre></small><br><h3>Calculated (if empty):</h3><small><pre>const industries = MEAN_LIST(funds, 'coreIndustry', 0.3);\nreturn getAllIndustries(industries);\n</pre></small>",
        type: 'select',
        required: false,
        field: 'allIndustries',
        selectGroup: 'allIndustries',
        multiple: true,
        filterParams: {
            values: ['25', '40', '45', '50', '1010', '1510', '2010', '2020', '2030', '2510', '2520', '2530', '2550', '3020', '3510', '3520', '4020', '4030', '4510', '4520', '4530', '5010', '5020', '5510', '6010'],
        },
    }, {
        headerName: 'All Strategies',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>peStrategies</pre></small><br><h3>Dictionary:</h3><small><pre>GP_STRATEGIES</pre></small><br><h3>Calculated (if empty):</h3><small><pre>MEAN_LIST(funds, 'allStrategies', 0.2)</pre></small>",
        type: 'select',
        required: false,
        field: 'allStrategies',
        selectGroup: 'GP_STRATEGIES',
        multiple: true,
        filterParams: {
            values: ['PIPE', 'Buyout', 'Growth', 'Balanced', 'Turnaround', 'Secondaries', 'Co-investment', 'Venture Capital', 'Direct Secondaries', 'Special Situations', 'Mezzanime/Debt/Loans'],
        },
    }, {
        headerName: 'Core Countries',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>SPLIT(peGeographies)</pre></small>",
        type: 'select',
        required: false,
        field: 'coreCountries',
        selectGroup: 'coreCountries',
        multiple: true,
        filterParams: {
            values: ['Europe', 'North America', 'France', 'US', 'Northeast', 'Netherlands', 'UK', 'Global', 'Spain', 'China', 'India', 'Southeast', 'West', 'Central America', 'South America', 'Canada', 'Colombia', 'Israel', 'United Arab Emirates', 'Asia', 'Emerging Markets', 'MENA', 'Middle East', 'North Africa', 'Central and East Europe', 'Italy', 'Poland', 'Turkey', 'Portugal', 'Southwest', 'Midwest', 'Germany', 'Denmark', 'Belgium', 'Luxembourg', 'Africa', 'Americas', 'West Europe', 'Brazil', 'Singapore', 'Taiwan', 'Sweden', 'Austria', 'Bulgaria', 'Croatia', 'Czech Republic', 'Estonia', 'Hungary', 'Latvia', 'Liechtenstein', 'Lithuania', 'Romania', 'Serbia', 'Slovakia', 'Slovenia', 'Switzerland', 'Ukraine', 'OECD', 'Belarus', 'Moldova', 'ASEAN', 'Asia and Rest of World', 'Australasia', 'South Asia', 'Egypt', 'Japan', 'Mexico', 'Thailand', 'Vietnam', 'Sub-Saharan Africa', 'Ethiopia', 'Morocco', 'Burundi', 'Comoro Islands', 'Djibouti', 'Eritrea', 'Kenya', 'Madagascar', 'Mauritius', 'Reunion', 'Rwanda', 'Seychelles', 'Somalia', 'Tanzania', 'Uganda', 'Bosnia & Herzegovina', 'Cyprus', 'Greece', 'Kosovo', 'Macedonia', 'Montenegro', 'Frontier Markets', 'Nigeria', 'Russia', 'Nordic', 'Central Asia', 'Albania', 'Finland', 'Armenia', 'Azerbaijan', 'Georgia', 'Kazakhstan', 'Kyrgyzstan', 'Tajikistan', 'Turkmenistan', 'Uzbekistan', 'BRIC', 'EU', 'Greater China', 'Australia', 'Chile', 'Hong Kong', 'Ireland', 'Malaysia', 'New Zealand', 'Norway', 'Philippines', 'South Korea', 'Myanmar', 'Hong Kong SAR - China', 'Pakistan', 'Iceland', 'Bahrain', 'Qatar', 'Saudi Arabia', 'Argentina', 'Peru', 'Botswana', 'Democratic Republic of Congo', 'Liberia', 'Mozambique', 'Namibia', 'South Africa', 'Ghana', 'Ivory Coast', 'Malawi', 'Sierra Leone', 'Zambia', 'Bermuda', 'Bolivia', 'Ecuador', 'Caribbean', 'Senegal', 'Tunisia', 'Puerto Rico', 'Cameroon', 'Zimbabwe', 'Malta', 'Far East', 'GCC', 'Indonesia', 'Mongolia', 'Iran', 'Angola', 'Isle of Man', 'US Virgin Islands', 'North Korea', 'Turks and Caicos Islands', 'Costa Rica', 'Guatemala', 'Honduras', 'Panama', 'Paraguay', 'Uruguay', 'Cambodia', 'Nepal', 'Algeria', 'Jordan', 'Lebanon', 'Palestine', 'Syria', 'Brunei', 'Laos', 'Benin', 'Burkina Faso', 'Central African Republic', 'Chad', 'Congo', 'Gabon', 'Guinea', 'Haiti', 'Niger', 'Togo', 'Vanuatu', 'Sri Lanka', 'Other', 'Taiwan - China', 'Cuba', 'Jersey', 'Bangladesh', 'El Salvador', 'Nicaragua', 'Swaziland', 'Federated States of Micronesia', 'Fiji', 'Kiribati', 'Papua New Guinea', 'Samoa', 'Solomon Islands', 'Iraq', 'Yemen', 'Belize', 'Greenland', 'Dominican Republic', 'Curaçao', 'Guinea Bissau', 'Lesotho', 'Mali', 'South Sudan', 'Monaco', 'Macao SAR - China', 'Andorra', 'Mauritania', 'Afghanistan', 'French Caribbean', 'Guyana', 'Gibraltar', 'Barbados', 'Venezuela', 'Libya', 'Sudan', 'Timor-Leste', 'Faroe Islands', 'Jamaica', 'Gambia', 'Kuwait', 'Netherlands Antilles', 'Guernsey', 'Oman', 'Aruba', 'Bahamas', 'Trinidad and Tobago'],
        },
    }, {
        headerName: 'Main Asset Class',
        headerTooltip: "<h3>Dictionary:</h3><small><pre>ASSET_CLASSES</pre></small><br><h3>Calculated (if empty):</h3><small><pre>MEAN(funds, 'coreAssetClass', 0.7)</pre></small>",
        type: 'select',
        required: false,
        field: 'mainAssetClass',
        selectGroup: 'ASSET_CLASSES',
        multiple: true,
        filterParams: {
            values: ['Multi', 'Hedge Funds', 'Real Assets', 'Private Debt', 'Private Equity', 'Venture Capital'],
        },
    }],
}, {
    headerName: 'Activity',
    children: [{
        headerName: 'Funds Total',
        headerTooltip: '<h3>Calculated (if empty):</h3><small><pre>fundsFinalised + fundsActive + fundsRaising</pre></small>',
        type: 'number',
        required: false,
        field: 'fundsTotal',
    }, {
        headerName: 'Deals Number',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'dealsNumber',
    }, {
        headerName: 'Funds Active',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'fundsActive',
    }, {
        headerName: 'Funds Closed',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>peTotalNoOfFundsClosed</pre></small><br><h3>Calculated (if empty):</h3><small><pre>fundsFinalised + fundsActive</pre></small>",
        type: 'number',
        required: false,
        field: 'fundsClosed',
    }, {
        headerName: 'Number Exits',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'numberExits',
    }, {
        headerName: 'Funds Raising',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'fundsRaising',
    }, {
        headerName: 'Lastdeal Date',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'lastdealDate',
    }, {
        headerName: 'Funds Finalised',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'fundsFinalised',
    }, {
        headerName: 'Assets Under Mgmt',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'assetsUnderMgmt',
    }],
}, {
    headerName: 'QEF interactions',
    children: [{
        headerName: 'Update Date',
        headerTooltip: "<h3>From 'preqin' source:</h3><small><pre>FROM_DATE(peDateUpdated, EXCEL)</pre></small>",
        type: 'date',
        required: false,
        field: 'updateDate',
    }, {
        headerName: 'Qef Last Status',
        headerTooltip: null,
        type: 'string',
        required: false,
        field: 'qefLastStatus',
    }, {
        headerName: 'Interaction Last',
        headerTooltip: null,
        type: 'date',
        required: false,
        field: 'interactionLast',
    }, {
        headerName: 'Interaction Number',
        headerTooltip: null,
        type: 'number',
        required: false,
        field: 'interactionNumber',
    }],
}, {
    headerName: 'Fundraising',
    children: [{
        headerName: 'Fundraising Status',
        headerTooltip: null,
        type: 'select',
        required: false,
        field: 'fundraisingStatus',
        selectGroup: 'fundraisingStatus',
        multiple: true,
        filterParams: {
            values: [],
        },
    }, {
        headerName: 'Fundraising Next Start',
        headerTooltip: null,
        type: 'date',
        required: false,
        field: 'fundraisingNextStart',
    }],
}]

const selectGroups = {
    COUNTRIES: {
        'n/a': 'n/a', Chad: 'Chad', Cuba: 'Cuba', Fiji: 'Fiji', Guam: 'Guam', Iran: 'Iran', Iraq: 'Iraq', Mali: 'Mali', Niue: 'Niue', Oman: 'Oman', Peru: 'Peru', Togo: 'Togo', Aruba: 'Aruba', Benin: 'Benin', Chile: 'Chile', China: 'China', Congo: 'Congo', Egypt: 'Egypt', Gabon: 'Gabon', Ghana: 'Ghana', Haiti: 'Haiti', India: 'India', Italy: 'Italy', Japan: 'Japan', Kenya: 'Kenya', Libya: 'Libya', Macao: 'Macao', Malta: 'Malta', Nauru: 'Nauru', Nepal: 'Nepal', Niger: 'Niger', Palau: 'Palau', Qatar: 'Qatar', Samoa: 'Samoa', Spain: 'Spain', Sudan: 'Sudan', Syria: 'Syria', Tonga: 'Tonga', Yemen: 'Yemen', Angola: 'Angola', Belize: 'Belize', Bhutan: 'Bhutan', Brazil: 'Brazil', Canada: 'Canada', Cyprus: 'Cyprus', France: 'France', Gambia: 'Gambia', Greece: 'Greece', Guinea: 'Guinea', Guyana: 'Guyana', Israel: 'Israel', Jersey: 'Jersey', Jordan: 'Jordan', Kuwait: 'Kuwait', Latvia: 'Latvia', Malawi: 'Malawi', Mexico: 'Mexico', Monaco: 'Monaco', Norway: 'Norway', Panama: 'Panama', Poland: 'Poland', Russia: 'Russia', Rwanda: 'Rwanda', Serbia: 'Serbia', Sweden: 'Sweden', Taiwan: 'Taiwan', Turkey: 'Turkey', Tuvalu: 'Tuvalu', Uganda: 'Uganda', Zambia: 'Zambia', Albania: 'Albania', Algeria: 'Algeria', Andorra: 'Andorra', Armenia: 'Armenia', Austria: 'Austria', Bahamas: 'Bahamas', Bahrain: 'Bahrain', Belarus: 'Belarus', Belgium: 'Belgium', Bermuda: 'Bermuda', Bolivia: 'Bolivia', Burundi: 'Burundi', Comoros: 'Comoros', Croatia: 'Croatia', Denmark: 'Denmark', Ecuador: 'Ecuador', Eritrea: 'Eritrea', Estonia: 'Estonia', Finland: 'Finland', Georgia: 'Georgia', Germany: 'Germany', Grenada: 'Grenada', Hungary: 'Hungary', Iceland: 'Iceland', Ireland: 'Ireland', Jamaica: 'Jamaica', Lebanon: 'Lebanon', Lesotho: 'Lesotho', Liberia: 'Liberia', Mayotte: 'Mayotte', Moldova: 'Moldova', Morocco: 'Morocco', Myanmar: 'Myanmar', Namibia: 'Namibia', Nigeria: 'Nigeria', Reunion: 'Reunion', Romania: 'Romania', Senegal: 'Senegal', Somalia: 'Somalia', Tokelau: 'Tokelau', Tunisia: 'Tunisia', Ukraine: 'Ukraine', Uruguay: 'Uruguay', Vanuatu: 'Vanuatu', Vietnam: 'Vietnam', Anguilla: 'Anguilla', Barbados: 'Barbados', Botswana: 'Botswana', Bulgaria: 'Bulgaria', Cambodia: 'Cambodia', Cameroon: 'Cameroon', Colombia: 'Colombia', Djibouti: 'Djibouti', Dominica: 'Dominica', Ethiopia: 'Ethiopia', Guernsey: 'Guernsey', Honduras: 'Honduras', Kiribati: 'Kiribati', Malaysia: 'Malaysia', Maldives: 'Maldives', Mongolia: 'Mongolia', Pakistan: 'Pakistan', Paraguay: 'Paraguay', Portugal: 'Portugal', Slovakia: 'Slovakia', Slovenia: 'Slovenia', Suriname: 'Suriname', Tanzania: 'Tanzania', Thailand: 'Thailand', Zimbabwe: 'Zimbabwe', Argentina: 'Argentina', Australia: 'Australia', Gibraltar: 'Gibraltar', Greenland: 'Greenland', Guatemala: 'Guatemala', 'Hong Kong': 'Hong Kong', Indonesia: 'Indonesia', Lithuania: 'Lithuania', Macedonia: 'Macedonia', Mauritius: 'Mauritius', Nicaragua: 'Nicaragua', Palestine: 'Palestine', Singapore: 'Singapore', 'Sri Lanka': 'Sri Lanka', Swaziland: 'Swaziland', Venezuela: 'Venezuela', Antarctica: 'Antarctica', Azerbaijan: 'Azerbaijan', Bangladesh: 'Bangladesh', 'Cabo Verde': 'Cabo Verde', 'Costa Rica': 'Costa Rica', Guadeloupe: 'Guadeloupe', Kazakhstan: 'Kazakhstan', Kyrgyzstan: 'Kyrgyzstan', Luxembourg: 'Luxembourg', Madagascar: 'Madagascar', Martinique: 'Martinique', Mauritania: 'Mauritania', Montenegro: 'Montenegro', Montserrat: 'Montserrat', Mozambique: 'Mozambique', 'San Marino': 'San Marino', Seychelles: 'Seychelles', Tajikistan: 'Tajikistan', Uzbekistan: 'Uzbekistan', Afghanistan: 'Afghanistan', 'El Salvador': 'El Salvador', 'Isle of Man': 'Isle of Man', Netherlands: 'Netherlands', 'New Zealand': 'New Zealand', 'North Korea': 'North Korea', Philippines: 'Philippines', 'Puerto Rico': 'Puerto Rico', 'Saint Lucia': 'Saint Lucia', 'South Korea': 'South Korea', 'South Sudan': 'South Sudan', Switzerland: 'Switzerland', 'Timor-Leste': 'Timor-Leste', 'Burkina Faso': 'Burkina Faso', 'Cook Islands': 'Cook Islands', 'Saint Helena': 'Saint Helena', 'Saudi Arabia': 'Saudi Arabia', 'Sierra Leone': 'Sierra Leone', 'South Africa': 'South Africa', Turkmenistan: 'Turkmenistan', 'Bouvet Island': 'Bouvet Island', 'Faroe Islands': 'Faroe Islands', 'French Guiana': 'French Guiana', 'Guinea-Bissau': 'Guinea-Bissau', Liechtenstein: 'Liechtenstein', 'New Caledonia': 'New Caledonia', 'United States': 'United States', 'American Samoa': 'American Samoa', 'Cayman Islands': 'Cayman Islands', 'Czech Republic': 'Czech Republic', "Côte D'Ivoire": "Côte D'Ivoire", 'Norfolk Island': 'Norfolk Island', 'United Kingdom': 'United Kingdom', 'Western Sahara': 'Western Sahara', 'Solomon Islands': 'Solomon Islands', 'Christmas Island': 'Christmas Island', 'Marshall Islands': 'Marshall Islands', 'Papua New Guinea': 'Papua New Guinea', 'Pitcairn Islands': 'Pitcairn Islands', 'Brunei Darussalam': 'Brunei Darussalam', 'Equatorial Guinea': 'Equatorial Guinea', 'US Virgin Islands': 'US Virgin Islands', 'Wallis and Futuna': 'Wallis and Futuna', 'Dominican Republic': 'Dominican Republic', 'Antigua and Barbuda': 'Antigua and Barbuda', 'Trinidad and Tobago': 'Trinidad and Tobago', 'Netherlands Antilles': 'Netherlands Antilles', 'United Arab Emirates': 'United Arab Emirates', 'Saint Kitts and Nevis': 'Saint Kitts and Nevis', 'Sao Tome and Principe': 'Sao Tome and Principe', 'Bosnia and Herzegovina': 'Bosnia and Herzegovina', 'British Virgin Islands': 'British Virgin Islands', 'Central African Republic': 'Central African Republic', 'Northern Mariana Islands': 'Northern Mariana Islands', 'Turks and Caicos Islands': 'Turks and Caicos Islands', 'Saint Pierre and Miquelon': 'Saint Pierre and Miquelon', 'Federated States of Micronesia': 'Federated States of Micronesia', "Lao People's Democratic Republic": "Lao People's Democratic Republic", 'Saint Vincent and the Grenadines': 'Saint Vincent and the Grenadines', 'Heard Island and McDonald Islands': 'Heard Island and McDonald Islands', 'Congo, The Democratic Republic of the': 'Congo, The Democratic Republic of the',
    },
    REGIONS_A: {
        DACH: 'DACH', Italy: 'Italy', Africa: 'Africa', Europe: 'Europe', France: 'France', Global: 'Global', Nordic: 'Nordic', Benelux: 'Benelux', Americas: 'Americas', 'Arab States': 'Arab States', 'Latin America': 'Latin America', 'North America': 'North America', 'Asia & Pacific': 'Asia & Pacific', 'Rest of Europe': 'Rest of Europe', 'United Kingdom': 'United Kingdom', 'Frontier/Emerging Markets': 'Frontier/Emerging Markets',
    },
    REGIONS_B: {
        Africa: 'Africa', Europe: 'Europe', Global: 'Global', 'Arab States': 'Arab States', 'Latin America': 'Latin America', 'North America': 'North America', 'Asia & Pacific': 'Asia & Pacific', 'Frontier/Emerging Markets': 'Frontier/Emerging Markets',
    },
    qefRegion: {},
    COMPANIES: {
        'n/a': 'n/a', Large: 'Large', Small: 'Small', 'Mid-Market': 'Mid-Market',
    },
    invPosition: {
        'Co-Lead': 'Co-Lead', Lead: 'Lead', 'Co-investing': 'Co-investing', 'Sole Investor': 'Sole Investor',
    },
    teamQuality: {},
    coreIndustry: {
        25: '25', 45: '45', 1010: '1010', 1510: '1510', 2010: '2010', 2020: '2020', 2030: '2030', 2510: '2510', 2520: '2520', 2530: '2530', 2550: '2550', 3020: '3020', 3510: '3510', 3520: '3520', 4020: '4020', 4030: '4030', 4510: '4510', 4520: '4520', 4530: '4530', 5010: '5010', 5020: '5020', 5510: '5510', 6010: '6010', 'Generalist (without focus)': 'Generalist (without focus)', 'Multi-sector (few key sectors)': 'Multi-sector (few key sectors)',
    },
    CURRENCIES: {
        DM: 'DM', AED: 'AED', AUD: 'AUD', BRL: 'BRL', CAD: 'CAD', CHF: 'CHF', CLP: 'CLP', COP: 'COP', DKK: 'DKK', EEK: 'EEK', EUR: 'EUR', GBP: 'GBP', HRK: 'HRK', HUF: 'HUF', ILS: 'ILS', ISK: 'ISK', JPY: 'JPY', KRW: 'KRW', MXN: 'MXN', NOK: 'NOK', NZD: 'NZD', PEN: 'PEN', PLN: 'PLN', RMB: 'RMB', RUB: 'RUB', SEK: 'SEK', SGD: 'SGD', TTD: 'TTD', TZS: 'TZS', USD: 'USD', ZAR: 'ZAR',
    },
    GP_FIRM_STRATEGIES: {
        Buyout: 'Buyout', Growth: 'Growth', Hybrid: 'Hybrid', Balanced: 'Balanced', Turnaround: 'Turnaround', 'Real Assets': 'Real Assets', 'Co-investment': 'Co-investment', 'Direct Secondaries': 'Direct Secondaries', 'Mezzanime/Debt/Loans': 'Mezzanime/Debt/Loans', 'Venture / Late Stage': 'Venture / Late Stage',
    },
    SHAREHOLDING: {
        Minority: 'Minority', Controlling: 'Controlling', 'No Preference': 'No Preference', 'Prefer Minority': 'Prefer Minority', 'Prefer Controlling': 'Prefer Controlling',
    },
    allIndustries: {
        25: '25', 40: '40', 45: '45', 50: '50', 1010: '1010', 1510: '1510', 2010: '2010', 2020: '2020', 2030: '2030', 2510: '2510', 2520: '2520', 2530: '2530', 2550: '2550', 3020: '3020', 3510: '3510', 3520: '3520', 4020: '4020', 4030: '4030', 4510: '4510', 4520: '4520', 4530: '4530', 5010: '5010', 5020: '5020', 5510: '5510', 6010: '6010',
    },
    GP_STRATEGIES: {
        PIPE: 'PIPE', Buyout: 'Buyout', Growth: 'Growth', Balanced: 'Balanced', Turnaround: 'Turnaround', Secondaries: 'Secondaries', 'Co-investment': 'Co-investment', 'Venture Capital': 'Venture Capital', 'Direct Secondaries': 'Direct Secondaries', 'Special Situations': 'Special Situations', 'Mezzanime/Debt/Loans': 'Mezzanime/Debt/Loans',
    },
    coreCountries: {
        Europe: 'Europe', 'North America': 'North America', France: 'France', US: 'US', Northeast: 'Northeast', Netherlands: 'Netherlands', UK: 'UK', Global: 'Global', Spain: 'Spain', China: 'China', India: 'India', Southeast: 'Southeast', West: 'West', 'Central America': 'Central America', 'South America': 'South America', Canada: 'Canada', Colombia: 'Colombia', Israel: 'Israel', 'United Arab Emirates': 'United Arab Emirates', Asia: 'Asia', 'Emerging Markets': 'Emerging Markets', MENA: 'MENA', 'Middle East': 'Middle East', 'North Africa': 'North Africa', 'Central and East Europe': 'Central and East Europe', Italy: 'Italy', Poland: 'Poland', Turkey: 'Turkey', Portugal: 'Portugal', Southwest: 'Southwest', Midwest: 'Midwest', Germany: 'Germany', Denmark: 'Denmark', Belgium: 'Belgium', Luxembourg: 'Luxembourg', Africa: 'Africa', Americas: 'Americas', 'West Europe': 'West Europe', Brazil: 'Brazil', Singapore: 'Singapore', Taiwan: 'Taiwan', Sweden: 'Sweden', Austria: 'Austria', Bulgaria: 'Bulgaria', Croatia: 'Croatia', 'Czech Republic': 'Czech Republic', Estonia: 'Estonia', Hungary: 'Hungary', Latvia: 'Latvia', Liechtenstein: 'Liechtenstein', Lithuania: 'Lithuania', Romania: 'Romania', Serbia: 'Serbia', Slovakia: 'Slovakia', Slovenia: 'Slovenia', Switzerland: 'Switzerland', Ukraine: 'Ukraine', OECD: 'OECD', Belarus: 'Belarus', Moldova: 'Moldova', ASEAN: 'ASEAN', 'Asia and Rest of World': 'Asia and Rest of World', Australasia: 'Australasia', 'South Asia': 'South Asia', Egypt: 'Egypt', Japan: 'Japan', Mexico: 'Mexico', Thailand: 'Thailand', Vietnam: 'Vietnam', 'Sub-Saharan Africa': 'Sub-Saharan Africa', Ethiopia: 'Ethiopia', Morocco: 'Morocco', Burundi: 'Burundi', 'Comoro Islands': 'Comoro Islands', Djibouti: 'Djibouti', Eritrea: 'Eritrea', Kenya: 'Kenya', Madagascar: 'Madagascar', Mauritius: 'Mauritius', Reunion: 'Reunion', Rwanda: 'Rwanda', Seychelles: 'Seychelles', Somalia: 'Somalia', Tanzania: 'Tanzania', Uganda: 'Uganda', 'Bosnia & Herzegovina': 'Bosnia & Herzegovina', Cyprus: 'Cyprus', Greece: 'Greece', Kosovo: 'Kosovo', Macedonia: 'Macedonia', Montenegro: 'Montenegro', 'Frontier Markets': 'Frontier Markets', Nigeria: 'Nigeria', Russia: 'Russia', Nordic: 'Nordic', 'Central Asia': 'Central Asia', Albania: 'Albania', Finland: 'Finland', Armenia: 'Armenia', Azerbaijan: 'Azerbaijan', Georgia: 'Georgia', Kazakhstan: 'Kazakhstan', Kyrgyzstan: 'Kyrgyzstan', Tajikistan: 'Tajikistan', Turkmenistan: 'Turkmenistan', Uzbekistan: 'Uzbekistan', BRIC: 'BRIC', EU: 'EU', 'Greater China': 'Greater China', Australia: 'Australia', Chile: 'Chile', 'Hong Kong': 'Hong Kong', Ireland: 'Ireland', Malaysia: 'Malaysia', 'New Zealand': 'New Zealand', Norway: 'Norway', Philippines: 'Philippines', 'South Korea': 'South Korea', Myanmar: 'Myanmar', 'Hong Kong SAR - China': 'Hong Kong SAR - China', Pakistan: 'Pakistan', Iceland: 'Iceland', Bahrain: 'Bahrain', Qatar: 'Qatar', 'Saudi Arabia': 'Saudi Arabia', Argentina: 'Argentina', Peru: 'Peru', Botswana: 'Botswana', 'Democratic Republic of Congo': 'Democratic Republic of Congo', Liberia: 'Liberia', Mozambique: 'Mozambique', Namibia: 'Namibia', 'South Africa': 'South Africa', Ghana: 'Ghana', 'Ivory Coast': 'Ivory Coast', Malawi: 'Malawi', 'Sierra Leone': 'Sierra Leone', Zambia: 'Zambia', Bermuda: 'Bermuda', Bolivia: 'Bolivia', Ecuador: 'Ecuador', Caribbean: 'Caribbean', Senegal: 'Senegal', Tunisia: 'Tunisia', 'Puerto Rico': 'Puerto Rico', Cameroon: 'Cameroon', Zimbabwe: 'Zimbabwe', Malta: 'Malta', 'Far East': 'Far East', GCC: 'GCC', Indonesia: 'Indonesia', Mongolia: 'Mongolia', Iran: 'Iran', Angola: 'Angola', 'Isle of Man': 'Isle of Man', 'US Virgin Islands': 'US Virgin Islands', 'North Korea': 'North Korea', 'Turks and Caicos Islands': 'Turks and Caicos Islands', 'Costa Rica': 'Costa Rica', Guatemala: 'Guatemala', Honduras: 'Honduras', Panama: 'Panama', Paraguay: 'Paraguay', Uruguay: 'Uruguay', Cambodia: 'Cambodia', Nepal: 'Nepal', Algeria: 'Algeria', Jordan: 'Jordan', Lebanon: 'Lebanon', Palestine: 'Palestine', Syria: 'Syria', Brunei: 'Brunei', Laos: 'Laos', Benin: 'Benin', 'Burkina Faso': 'Burkina Faso', 'Central African Republic': 'Central African Republic', Chad: 'Chad', Congo: 'Congo', Gabon: 'Gabon', Guinea: 'Guinea', Haiti: 'Haiti', Niger: 'Niger', Togo: 'Togo', Vanuatu: 'Vanuatu', 'Sri Lanka': 'Sri Lanka', Other: 'Other', 'Taiwan - China': 'Taiwan - China', Cuba: 'Cuba', Jersey: 'Jersey', Bangladesh: 'Bangladesh', 'El Salvador': 'El Salvador', Nicaragua: 'Nicaragua', Swaziland: 'Swaziland', 'Federated States of Micronesia': 'Federated States of Micronesia', Fiji: 'Fiji', Kiribati: 'Kiribati', 'Papua New Guinea': 'Papua New Guinea', Samoa: 'Samoa', 'Solomon Islands': 'Solomon Islands', Iraq: 'Iraq', Yemen: 'Yemen', Belize: 'Belize', Greenland: 'Greenland', 'Dominican Republic': 'Dominican Republic', Curaçao: 'Curaçao', 'Guinea Bissau': 'Guinea Bissau', Lesotho: 'Lesotho', Mali: 'Mali', 'South Sudan': 'South Sudan', Monaco: 'Monaco', 'Macao SAR - China': 'Macao SAR - China', Andorra: 'Andorra', Mauritania: 'Mauritania', Afghanistan: 'Afghanistan', 'French Caribbean': 'French Caribbean', Guyana: 'Guyana', Gibraltar: 'Gibraltar', Barbados: 'Barbados', Venezuela: 'Venezuela', Libya: 'Libya', Sudan: 'Sudan', 'Timor-Leste': 'Timor-Leste', 'Faroe Islands': 'Faroe Islands', Jamaica: 'Jamaica', Gambia: 'Gambia', Kuwait: 'Kuwait', 'Netherlands Antilles': 'Netherlands Antilles', Guernsey: 'Guernsey', Oman: 'Oman', Aruba: 'Aruba', Bahamas: 'Bahamas', 'Trinidad and Tobago': 'Trinidad and Tobago',
    },
    ASSET_CLASSES: {
        Multi: 'Multi', 'Hedge Funds': 'Hedge Funds', 'Real Assets': 'Real Assets', 'Private Debt': 'Private Debt', 'Private Equity': 'Private Equity', 'Venture Capital': 'Venture Capital',
    },
    fundraisingStatus: {},
}

const generateRows = length => ([
    ...(Array.from({ length }).map((item, index) => {
        const id = 1 + index
        return {
            id,
            name: `+ND Capital ${id}`,
            qefId: null,
            hqCity: 'Woodside',
            admteam: null,
            invteam: 8,
            linkArx: randomBoolean(),
            opsteam: null,
            website: 'nd.capital',
            yearEst: 2002,
            numFunds: null,
            preqinId: 12537,
            hqAddress: '2983 Woodside Road',
            hqCountry: ['United States'],
            hqRegionA: [],
            hqRegionB: [],
            hqZipcode: '94062',
            qefRegion: [],
            fundsTotal: null,
            linkPreqin: null,
            staffTotal: 12,
            updateDate: '2019-12-03T00:00:00.000Z',
            companySize: ['Mid-Market'],
            dealsNumber: null,
            description: null,
            fundsActive: null,
            fundsClosed: 2,
            invPosition: ['Co-Lead', 'Lead', 'Co-investing'],
            numberExits: null,
            teamQuality: [],
            admteamOther: null,
            contactEmail: 'info@nd.capital',
            coreIndustry: ['Generalist (without focus)'],
            fundsRaising: null,
            lastdealDate: null,
            mainCurrency: ['EUR'],
            mainStrategy: ['Venture / Late Stage'],
            opsteamOther: null,
            shareholding: [],
            admteamSenior: null,
            allIndustries: ['3520', '1510', '4520', '5510', '45', '3510', '1010', '4530'],
            allStrategies: ['Venture Capital'],
            coreCountries: ['Europe', 'North America', 'France', 'US'],
            invteamJunior: null,
            invteamSenior: null,
            opsteamSenior: null,
            qefLastStatus: null,
            fundCurrencies: [],
            fundsFinalised: null,
            invteamPartner: null,
            mainAssetClass: [],
            opsteamPartner: null,
            assetsUnderMgmt: null,
            interactionLast: null,
            contactTelephone: '+1 650 241 1155',
            fundraisingStatus: [],
            interactionNumber: null,
            fundraisingNextStart: null,
            _meta: {
                staffTotal: [{
                    type: 'fg-color',
                    color: 'green',
                }],
            },
        }
    })),
])

const list = length => ({
    columns,
    rows: generateRows(length),
    selectGroups,

})

export default {
    list,
}
